import { render } from "./Demo2.vue?vue&type=template&id=8f52bd12&scoped=true&ts=true"
import script from "./Demo2.vue?vue&type=script&lang=ts"
export * from "./Demo2.vue?vue&type=script&lang=ts"

import "./Demo2.vue?vue&type=style&index=0&id=8f52bd12&lang=scss&scoped=true"

import exportComponent from "/Users/suhwanlim/Projects/pr/WorkoutHistory-Web/workout-history-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f52bd12"]])

export default __exports__